import styled from 'styled-components';
import { getSpace, mq, getColor, px2rem } from '../../../../stylesheets/tools';

const StyledEducationCategoryTeaser = styled.div`
  padding: ${getSpace('xl')} 0 ${getSpace('xxs')} 0;

  .category-teaser__select-topic {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${px2rem('20px')};
    color: ${getColor('darkGray')};
    margin-bottom: ${getSpace('xxs')};

    svg {
      height: ${px2rem('20px')};
      width: ${px2rem('20px')};
    }
  }
  .category-teaser__grid {
    display: flex;
    justify-content: center;

    ${mq('l')} {
      padding: ${getSpace('xxxl')} ${getSpace('xl')};
    }
  }
  .category-teaser__topic-texts {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-top: ${getSpace('m')};

    div > div {
      margin-top: ${getSpace('xxs')};
      max-width: ${px2rem('600px')};
    }
  }
  .category-teaser__link-container {
    padding-top: ${getSpace('m')};

    ${mq('l')} {
      padding-top: ${getSpace('l')};
    }

    .category-teaser__link {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: ${px2rem('15px')};

      ${mq('l')} {
        gap: ${px2rem('20px')};
      }

      .category-teaser__title {
        font-size: ${px2rem('20px')};

        ${mq('l')} {
          font-size: ${px2rem('24px')};
        }
      }

      .category-teaser__link-icon {
        background: black;
        color: white;
        height: ${px2rem('44px')};
        width: ${px2rem('44px')};
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;

        svg {
          height: ${px2rem('20px')};
          width: ${px2rem('20px')};
        }
        ${mq('l')} {
          height: ${px2rem('76px')};
          width: ${px2rem('76px')};

          svg {
            height: ${px2rem('30px')};
            width: ${px2rem('30px')};
          }
        }
      }
    }
  }
`;

export default StyledEducationCategoryTeaser;
